export abstract class SetCredentialsRequest {
    password: string;
    passwordRepeat: string;

    public constructor(obj: any = {}) {
        this.password = obj && obj.newPassword || null;
        this.passwordRepeat = obj && obj.confirmPassword || null;
    }
}
